const Assets = {
  IMAGE: {
    sliderBg: require("./sliderBg.png"),
    icon: require("./icon.png"),
    user: require("./Ellipse1.png"),
  },
};
export default Assets;
